module.exports = __webpack_public_path__ + "img/TECHNOLOGY-FRONX-BOOSTERGREEN-5.f5de6b23.jpg";